var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 47",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.069,5.234C40.069,2.343,37.726,0,34.835,0H11.241C8.35,0,6.007,2.343,6.007,5.234v35.609 c0,2.892,2.343,5.233,5.234,5.233h23.594c2.891,0,5.234-2.342,5.234-5.233V5.234z M27.121,39.732c0,0.541-0.438,0.979-0.979,0.979 h-6.089c-0.541,0-0.98-0.438-0.98-0.979v-1.074c0-0.541,0.439-0.979,0.98-0.979h6.089c0.541,0,0.979,0.438,0.979,0.979V39.732z  M34.353,31.156c0,1.088-0.883,1.973-1.973,1.973H13.696c-1.089,0-1.973-0.883-1.973-1.973V8.272c0-1.089,0.883-1.973,1.973-1.973 h18.685c1.091,0,1.974,0.883,1.974,1.973v22.884H34.353z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.706bd18a3c20b616642314ca0668714e.svg";
export { ForwardRef as ReactComponent };